/* Progressive enhancement: the guide link remains usable without this component. */
(() => {
  if (customElements.get('pf-size-help')) return;
  class PFSizeHelp extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
      const link = this.querySelector('[data-pf-size-open]');
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('[data-pf-size-close]');
      if (!link || !dialog || !close) return;
      this.dataset.ready = 'true';
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        dialog.showModal();
        document.documentElement.classList.add('pf-size-guide-open');
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!document.querySelector('dialog[data-pf-size-dialog][open]')) document.documentElement.classList.remove('pf-size-guide-open');
        if (link.isConnected) link.focus({preventScroll: true});
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog[open]')) {
        this.querySelector('dialog').close();
        if (!document.querySelector('dialog[data-pf-size-dialog][open]')) document.documentElement.classList.remove('pf-size-guide-open');
      }
    }
  }
  customElements.define('pf-size-help', PFSizeHelp);
})();
